module.exports = __webpack_public_path__ + "img/ME.2b8ef821.svg";